<template>
  <div id="customers" v-cloak>
    <div class="vx-card">
      <selectPlanList
        :show="showPlanList"
        @finish="onfinish"
        @close="closeSelectPlanList"
        :promoterId="promoterId"
      />
      <div class="vx-card__body card-body">
        <div class="vx-row mb-3">
          <div class="vx-col lg:w-1/2 w-full">
            <div class="dropdown-button-container">
              <vs-dropdown :vs-trigger-click="true">
                <vs-button
                  class="btn-drop vs-component vs-button bg_l_green"
                  color="success"
                  icon="add"
                  :vs-trigger-click="true"
                  v-has-permission="permission98"
                >
                  {{ $t("InsertSalesPartners") }}</vs-button
                >
                <vs-dropdown-menu id="agent-dp">
                  <vs-dropdown-item>
                    <router-link
                      :to="{ path: '/SalesPartners/CreateIndividual' }"
                    >
                      {{ $t("Individual") }}
                    </router-link>
                  </vs-dropdown-item>
                  <vs-dropdown-item>
                    <router-link :to="{ path: '/SalesPartners/CreateLegal' }">
                      {{ $t("Legal") }}
                    </router-link>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </div>
          <div class="vx-col flex justify-end lg:w-1/2 w-full mb-2">
            <filter-button @click="toggleShowFilters" />
          </div>
        </div>
        <form v-if="showFilters" class="filter-form">
          <div class="vx-row mb-6">
            <div class="vx-col lg:w-1/3 sm:w-1/2 w-full">
              <label class="lg:w-1/4 sm:w-1/2 mt-2">شخصیت طرف تجاری</label>
              <v-select
                label="name"
                :options="customers"
                class="lg:w-2/3 sm:w-1/2"
                v-model="gridSearchData.partyType"
                :reduce="(x) => x.id"
                :clearable="false"
                ref="agentType"
                dir="rtl"
              >
              </v-select>
            </div>
            <div class="vx-col lg:w-2/3 sm:w-1/2 w-full mt-6">
              <vs-button
                type="filled"
                class="float-right"
                @click.prevent="submitFilter()"
                >{{ $t("SubmitFilter") }}</vs-button
              >
              <vs-button
                type="filled"
                class="float-right"
                id="reset-btn"
                @click.prevent="resetForm"
                >{{ $t("ResetFilter") }}</vs-button
              >
            </div>
          </div>
        </form>

        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('Name') },
                { title: $t('SocialSecurityNumber') },
                { title: $t('PartyType') },
                { title: 'پلن فعال همیار فروش' },
                { title: $t('Action') },
                { title: 'جزییات' },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 12%">
                  <span v-if="row.partyType == 'PromoterIndividual'">
                    {{ row.firstName }} {{ row.lastName }}
                  </span>
                  <span v-if="row.partyType == 'PromoterLegal'">
                    {{ row.companyName }}
                  </span>
                </td>
                <td style="width: 10%">
                  <span v-if="row.socialSecurityNumber">
                    {{ row.socialSecurityNumber }}
                  </span>
                  <span v-else>-</span>
                </td>
                <td style="width: 13%; direction: ltr">
                  <span v-if="row.partyType == 'PromoterIndividual'">
                    {{ $t("Individual") }}
                  </span>
                  <span v-if="row.partyType == 'PromoterLegal'">
                    {{ $t("Legal") }}
                  </span>
                </td>
                <td style="width: 30%; direction: ltr">
                  {{
                    row.promoterPlanQuery == null
                      ? ""
                      : row.promoterPlanQuery.name
                  }}
                </td>

                <td style="width: 15%">
                  <div
                    class="w-full h-full flex gap-y-2 flex-wrap items-center justify-center"
                  >
                    <vs-button
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      icon="icon-edit"
                      class="bordered-btn"
                      @click.prevent="onShowPlanList(row)"
                      v-has-permission="permission91"
                    >
                      {{
                        row.promoterPlanQuery == null
                          ? "انتخاب پلن"
                          : "تغییر پلن"
                      }}
                    </vs-button>
                    <vs-button
                      v-if="row.promoterPlanQuery != null"
                      radius
                      color="danger"
                      size="small"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-x"
                      @click.prevent="onUnassignPlan(row)"
                      class="d-inline"
                      v-has-permission="permission92"
                    ></vs-button>
                  </div>
                </td>
                <td style="width: 16%">
                  <vs-button
                    color="primary"
                    type="border"
                    icon-pack="feather"
                    icon="icon-edit"
                    class="bordered-btn"
                    @click="isShowDetailsSalePartner(row)"
                    v-has-permission="permission94"
                  >
                    <router-link
                      :to="{
                        path:
                          '/SalesPartners/ShowDetailsSalePartner/' +
                          row.ownerId,
                        query: { promoter2: row },
                      }"
                    >
                      مشاهده پروفایل</router-link
                    >
                  </vs-button>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
#reset-btn {
  margin-left: 1.5rem;
  background: #3ec9d6 !important;
}
</style>
<style lang="scss">
input[type="checkbox"] {
  -ms-transform: scale(2); /* IE */
  -moz-transform: scale(2); /* FF */
  -webkit-transform: scale(2); /* Safari and Chrome */
  -o-transform: scale(2); /* Opera */
  transform: scale(2);
  padding: 10px;
}
.checkboxtext {
  font-size: 1vw;
  font-weight: bold;
  display: inline;
}
.bg_l_green {
  cursor: pointer;
}

.con-vs-checkbox {
  display: inline-flex;
  margin: 0px !important;
}

.filter-form {
  border-top: 1px dashed #ddd;
  padding-top: 0.5rem;
}

.filter-form
  .vs-button:not(.vs-radius):not(.includeIconOnly):not(.small):not(.large) {
  padding: 0.5rem 2rem;
}
</style>
<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import vSelect from "vue-select";
import selectPlanList from "./selectPlanList.vue";
import showDetailsSalePartner from "./ShowDetailsSalePartner.vue";
import { mapActions } from "vuex";
import FilterButton from "@/components/buttons/FilterButton.vue";

export default {
  data() {
    return {
      permission98: "CreatePromoterIndividual|CreatePromoterLegal",
      permission91: "AssignPromoterPlan",
      permission92: "UnAssignPromoterPlan",
      permission94: "GetPartyAccountsByOwner|GetAllSoldItemsByOwner",
      // "GetPartyAccountsByOwner|GetAllFinancialTransactions|GetAllSoldItemsByOwner",
      showPlanList: false,
      model: {},
      promoter: {},
      promoterId: "",
      customers: [
        { name: "حقیقی", id: 1 },
        { name: "حقوقی", id: 2 },
      ],
      gridDataSource: {
        type: "app",
        service: "Promotion/api/Promoters",
      },
      gridSearchData: {
        partyType: null,
      },
      showFilters: false,
      onShowDetailsSalePartner: false,
    };
  },
  methods: {
    ...mapActions({
      unAssignPlan: "SalesPartnerPlan/unAssignPlan",
    }),
    isShowDetailsSalePartner(row) {
      this.onShowDetailsSalePartner = true;
      this.promoter = row;
    },
    toggleShowFilters() {
      this.showFilters = !this.showFilters;
    },
    onUnassignPlan(row) {
      this.model.promoterId = row.id;
      this.unAssignPlan(this.model).then(() => {
        this.$refs.grid.renderGrid();
      });
    },
    closeSelectPlanList() {
      this.showPlanList = false;
    },
    onfinish() {
      this.closeSelectPlanList();
      this.onShowDetailsSalePartner = false;
      this.$refs.grid.renderGrid();
    },
    onShowPlanList(id) {
      this.promoterId = id.id;
      this.showPlanList = true;
    },
    submitFilter() {
      this.$refs.grid.renderGrid();
    },
    resetForm() {
      this.gridSearchData = {};
      setTimeout(() => {
        this.$refs.grid.renderGrid();
        this.$refs.SalePartnerype.clearSelection();
      }, 0);
    },
  },
  components: {
    DataGrid,
    selectPlanList,
    "v-select": vSelect,
    showDetailsSalePartner,
    FilterButton,
  },
};
</script>
